// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    // Pages
    'individual-employment-income.page.edit_draft.title': 'Edit Draft',

    // Buttons
    'individual-employment-income.button.cancel': 'Cancel',
    'individual-employment-income.button.draft': 'Save Draft',

    // Successes
    // The screen's own copy says "Employment income", not the longer entity name the
    // key carries. Kept verbatim from the pre-i18n page so the toast reads unchanged.
    'individual-employment-income.success.message.individual_employment_income_updated': 'Employment income has been updated',

    // Errors
    // "Individual employment income" is a mass noun, so both halves of the pluralised pair are
    // the same sentence. That is deliberate, not a copy-paste slip.
    'individual-employment-income.error.message.error_loading_page': 'Sorry, there was an error loading individual employment income.| Sorry, there was an error loading individual employment income.',
    'individual-employment-income.error.message.error_updating_individual_employment_income': 'Error updating employment income',
    // The viewer's compact panel says its own, shorter sentence — and, like the toast
    // above, names the short entity ("employment income") rather than the long one the
    // key carries. Kept verbatim from the pre-i18n panel so the panel reads unchanged.
    'individual-employment-income.viewer.error.message.error_loading_page': 'Error loading employment income.',

    // Links
    'individual-employment-income.link.retry': 'Click here to retry',
    // Likewise the viewer's link is the bare word, not "Click here to retry".
    'individual-employment-income.viewer.link.retry': 'Retry',
};
